(function (app, ng) {
    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Root.Policies.MoreDetail", {
            url: "/{MappedPolicyId}/MoreDetail",
            component: "policyMoreDetail",
            params: {
                item: null,
                query: null,
                cardTitle: null
            }
        });
    }]);
    
    app.component("policyMoreDetail", {
        templateUrl: "/App/States/Policies/MoreDetail/more-detail.html",
        controller: moreDetailController
    });

    moreDetailController.$inject = ["$stateParams", "$anchorScroll", "$location", "$state", "$filter"];
    function moreDetailController($stateParams, $anchorScroll, $location, $state, $filter) {
        let $ctrl = this;
        $ctrl.isArray = ng.isArray;

        $ctrl.$onInit = () => {
            $ctrl.loading = true;
            if (!$stateParams.query || !$stateParams.item) {
                return $state.go("Root.Policies.Detail", { MappedPolicyId: $stateParams.MappedPolicyId, fadeFromRight: false });
            }
            $ctrl.data = [];
            $ctrl.cardTitle = $stateParams.cardTitle.substring(0, $stateParams.cardTitle.length - 1) + " Details";
            $ctrl.animation = true;
            $stateParams.query($stateParams.item).then(data => {
                $ctrl.data = data;
            }).finally(function () {
                $ctrl.loading = false;
            });
        };

        $location.hash("detailContent");
        $anchorScroll();
        $ctrl.scrollTo = function (element) {
            $ctrl.pulse = element;
            $location.hash(element);
            $anchorScroll();
        };

        $ctrl.backToPolicy = function () {
            $state.go("Root.Policies.Detail", { MappedPolicyId: $stateParams.MappedPolicyId, fadeFromRight: false });
        };

        $ctrl.getKeys = function (object) {
            return Object.keys(object).filter(key => !key.includes("$$"));
        };

        $ctrl.deCamelize = function (term) {
            return term.replace(/([A-Z])/g, ' $1').trim();
        };

        $ctrl.NumOrGrouping = function (key) {
            if (key === 'Num' || key === 'Grouping') {
                return true;
            }
            return false;
        };

        $ctrl.reformat = function (key, val) {
            if (key.includes('On') || key.includes('Date') || key.includes('Dob')) {
                return $filter('date')(val);
            }
            else if (/(percent)/i.test(key) && val) {
                return val + "%";
            }
            else if (typeof val === "number" && key.includes('Value') && !key.includes('Amount')) {
                return $filter('currency')(val);
            }
            return val;
        };
    }
})(window.app, window.angular);
